var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('u-dialog', {
    attrs: {
      "name": "modal"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }, {
      key: "actions",
      fn: function () {
        return [_c('v-row', {
          attrs: {
            "no-gutters": "",
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "auto"
          }
        }, [_c('v-btn', _vm._b({
          staticClass: "v-size--xx-large w-100 min-w-sm-200px",
          on: {
            "click": _vm.submit
          }
        }, 'v-btn', Object.assign({}, _vm.btn_primary), false), [_vm._v("문의하기")])], 1)], 1)];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xxs pa-0"
  }, [_vm._v("문의하기")])], 1), _c('v-simple-table', {
    staticClass: "v-data-table--no-hover"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "w-20"
  }, [_vm._v("문의유형")]), _c('td', [_c('v-select', {
    attrs: {
      "items": _vm.types,
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "placeholder": "문의유형을 선택해 주세요."
    },
    model: {
      value: _vm.inquire.type,
      callback: function ($$v) {
        _vm.$set(_vm.inquire, "type", $$v);
      },
      expression: "inquire.type"
    }
  })], 1)]), _c('tr', [_c('th', [_vm._v("제목")]), _c('td', [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.inquire.subject,
      callback: function ($$v) {
        _vm.$set(_vm.inquire, "subject", $$v);
      },
      expression: "inquire.subject"
    }
  })], 1)]), _c('tr', [_c('th', [_vm._v("내용")]), _c('td', [_c('v-textarea', {
    staticClass: "pb-8px",
    attrs: {
      "auto-grow": "",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.inquire.content,
      callback: function ($$v) {
        _vm.$set(_vm.inquire, "content", $$v);
      },
      expression: "inquire.content"
    }
  }), _c('v-checkbox', _vm._b({
    staticClass: "d-inline-flex",
    attrs: {
      "value": true,
      "hide-details": "",
      "id": "secret"
    },
    model: {
      value: _vm.inquire.secret,
      callback: function ($$v) {
        _vm.$set(_vm.inquire, "secret", $$v);
      },
      expression: "inquire.secret"
    }
  }, 'v-checkbox', Object.assign({}, _vm.checkbox_primary), false)), _c('label', {
    staticClass: "d-inline-flex align-center",
    attrs: {
      "for": "secret"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "16",
      "src": "/images/icon/icon-lock.svg"
    }
  }), _c('span', {
    staticClass: "txt ml-4px"
  }, [_vm._v("비밀글")])], 1)], 1)]), _c('tr', [_c('th', [_vm._v("첨부파일 등록")]), _c('td', [_c('form-files', {
    model: {
      value: _vm.inquire.images,
      callback: function ($$v) {
        _vm.$set(_vm.inquire, "images", $$v);
      },
      expression: "inquire.images"
    }
  })], 1)])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }